import React, { useState } from "react";
import { Button, Modal, Form, Toast, ToastContainer } from "react-bootstrap"; // Toast əlavə edildi
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./Header.module.css";
import { BASE_URL } from "../../constants";
import { apiFetch } from "../../utils/apiFetch";

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState("Təklif");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Toast state-ləri
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const isOffer = type === "Təklif";

  const handleSend = async () => {
    if (!message.trim()) {
      setToastVariant("warning");
      setToastMessage("Zəhmət olmasa mesaj daxil edin!");
      setShowToast(true);
      return;
    }

    const payload = { category: type, message, status: "Yeni" };

    try {
      setLoading(true);

      const response = await apiFetch(BASE_URL+"/feedbacks", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        setToastVariant("success");
        setToastMessage("Mesajınız uğurla göndərildi! Teşekkür edirik.");
        setShowToast(true);
        
        setMessage("");
        setShowModal(false); 
      } else {
        throw new Error();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`${styles.header}`}>

      {/* Open button */}
      <Button
        variant="primary"
        size="sm"
        className={styles.btn_offer}
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-lightbulb"></i> Təklifiniz var?
      </Button>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Təklifiniz və ya probleminiz var?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Kateqoriya:</Form.Label>
              <Form.Select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className={isOffer ? "bg-success text-white shadow-none" : "bg-danger text-white shadow-none"}
              >
                <option value="Təklif">Təklif</option>
                <option value="Problem">Problem</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">
                {isOffer ? "Təklifinizi yazın:" : "Problemi təsvir edin:"}
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Buraya yazın..."
                className="shadow-none"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          
          <Button variant="primary" onClick={handleSend} disabled={loading}>
            {loading ? "Göndərilir..." : "Göndər"} <i className="bi bi-send ms-1"></i>
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --- Toast Bildiriş Sistemi --- */}
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast 
          onClose={() => setShowToast(false)} 
          show={showToast} 
          delay={4000} 
          autohide 
          bg={toastVariant}
        >
          <Toast.Header closeButton={false} className="bg-white text-dark">
            <i className={`bi bi-info-circle-fill me-2 text-${toastVariant}`}></i>
            <strong className="me-auto">Məlumat</strong>
            <small>İndi</small>
          </Toast.Header>
          <Toast.Body className="text-white fw-medium">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>

    </div>
  );
};

export default Header;